import { useEffect } from 'react'
import { useRouter } from 'next/router'

// This route used to redirect to the Beluga Eats app-store pages. The app has
// been retired, but old QR codes and text messages still point here, so keep
// the route alive and send visitors to the homepage instead.
export default function Download(): JSX.Element {
  const router = useRouter()

  useEffect(() => {
    router.replace('/')
  }, [router])

  return <></>
}
